import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { removeEmpty, buildQueryParams } from '../../utils/object';

// Define the API slice
export const clientApi = createApi({
  reducerPath: 'clientApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getClients: builder.query({
      query: ({ page, limit, search } = {}) => ({
        url: 'client',
        params: buildQueryParams({ page, limit, search }),
      }),
    }),
    addClient: builder.mutation({
      query: (newClient) => ({
        url: 'client',
        method: 'POST',
        body: newClient,
      }),
    }),
    updateClient: builder.mutation({
      query: ({ id, updatedClient }) => ({
        url: `client/${id}`,
        method: 'PUT',
        body: updatedClient,
      }),
    }),
    getClientFeatureFlags: builder.query({
      query: (clientId) => `configuration/${clientId}/flags`,
    }),
    getClientFilters: builder.query({
      query: (args = {}) => {
        const params = removeEmpty(args);

        return {
          url: 'client/filters',
          ...(Object.keys(params).length > 0 && { params: params }),
        };
      },
    }),
  }),
});

export const {
  useGetClientsQuery,
  useAddClientMutation,
  useUpdateClientMutation,
  useGetClientFiltersQuery,
  useGetClientFeatureFlagsQuery,
} = clientApi;
